export enum PopupType {
    newEstimate,
    importEstimate,
    deleteEstimate,
    estimates,
    costbooks,
    customerInfo,
    companyInfo,
    estimateQboInfo,
    jobInfo,
    accountingSettings,
    qboProgressive,
    taxRates,
    markups,
    percentages,
    areaCostsModifications,

    estimateRename,
    estimateSaveAs,
    estimateImport,
    estimateExport,

    costPicker,
    estimateTextRow,
    estimateCostRow,
    estimateSubtotalRow,
    
    confirmation,
    image,
    costbookProperties,
    exportBid,
    missingInfo,
    exportInvoice,
    qboExportResult,
    printEstimate
}


// WEBPACK FOOTER //
// ./ClientApp/services/popups/popupType.ts